import React from 'react';
import { MapPin as LucideMapPin } from 'lucide-react';

interface MapPinProps {
  width?: number;
  height?: number;
  className?: string;
  style?: React.CSSProperties;
}

const MapPin: React.FC<MapPinProps> = ({ width = 24, height = 24, className, style }) => (
  <LucideMapPin width={width} height={height} className={className} style={style} aria-hidden strokeWidth={2} />
);

export default MapPin;
